__turbopack_context__.v({
  "job": "inline-search-module-scss-module__RSixWG__job",
  "location": "inline-search-module-scss-module__RSixWG__location",
  "search": "inline-search-module-scss-module__RSixWG__search",
  "typeaheads": "inline-search-module-scss-module__RSixWG__typeaheads",
});
